module.exports = __webpack_public_path__ + "d7d544195bf30dcfc0cec146efb83cdf.pdf";